module.exports = __webpack_public_path__ + "static/media/Toby.a8ce2f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/patrons/Toby.jpg
// module id = 696
// module chunks = 0